const estilo_moving_truck = {
  colors: {
      primary: "#f91a1a"
  }
}

module.exports = {
  estilo_moving_truck
}
